import * as ko from 'knockout';

import { BaseForm } from './base_form';
import * as marketSegmentsApi from '../api/market_segments';
import { Deferred } from '../utils/deferred';
import { asI18nText } from '../i18n_text';
import { createWithComponent } from '../utils/ko_utils';
import { MarketSegment } from '../models/market_segment';
import { canEditMarketSegments } from '../permissions';

let template = require('raw-loader!../../templates/market_segment_edit.html').default;

class MarketSegmentEditScreen extends BaseForm<marketSegmentsApi.MarketSegmentData> {
  entity = ko.validatedObservable<MarketSegment>(null);
  canEdit = canEditMarketSegments();

  constructor(
    params: {
      id: string;
      initialName?: string;
      result?: Deferred<marketSegmentsApi.MarketSegmentData>;
    },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    let requestPromise = params.id ? marketSegmentsApi.retrieve(params.id) : undefined;
    let promise = Promise.all([requestPromise]).then(([data]) => {
      this.entity(new MarketSegment(data));
      if (!data && params.initialName) {
        this.entity().nameJson(asI18nText(params.initialName));
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (this.validateLocal(this.entity)) {
      let data = this.entity().toData();
      this.executeSaveRequest(marketSegmentsApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.entity(), validation);
      });
    }
  };
}

export let marketSegmentEdit = {
  name: 'market-segment-edit',
  viewModel: createWithComponent(MarketSegmentEditScreen),
  template: template,
};

ko.components.register(marketSegmentEdit.name, marketSegmentEdit);
